const state = {
    brands: [
        {
            img: "logo_le lis_blanc.png",
            collection: 'le-lis-blanc',
            id: 2774,
            name: 'Le Lis Blanc',

        },
        {
            img: "logo_John_John.png",
            collection: 'john-john',
            id: 2778,
            name: 'John John'
        },
        {
            img: "logo_bobo.png",
            collection: 'bobo',
            id: 2773,
            name: 'Bo.Bô'
        },
        {
            img: "rosa_cha.png",
            collection: 'rosa-cha',
            id: 2775,
            name: 'Rosa Chá'
        },
        {
            img: "logo_dudalina.png",
            collection: 'dudalina',
            id: 2776,
            name: 'Dudalina'
        },
        {
            img: "logo_individual.png",
            collection: 'individual',
            id: 2777,
            name: 'Individual'
        },
    ]
}

export { state }